module.exports = __webpack_public_path__ + "static/media/pearlchain_logo.8d8ee2f3.png";